// extracted by mini-css-extract-plugin
var _1 = "EmbedPostContent-module__animateUploadProgressBarWidth--JpmUl";
var _2 = "EmbedPostContent-module__animatedBackground--UFqdj";
var _3 = "EmbedPostContent-module__container--OG5B7";
var _4 = "660px";
var _5 = "EmbedPostContent-module__hasFooter--YV7TY";
var _6 = "EmbedPostContent-module__inner--zaIY2";
var _7 = "EmbedPostContent-module__overlay--oBGh0";
var _8 = "EmbedPostContent-module__stateBar--oqDAa";
var _9 = "EmbedPostContent-module__tocContainer--kLnz7";
var _a = "EmbedPostContent-module__tocTitle--DNlbg";
var _b = "EmbedPostContent-module__tocWrapper--ISpel";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "contentMaxWidth", _5 as "hasFooter", _6 as "inner", _7 as "overlay", _8 as "stateBar", _9 as "tocContainer", _a as "tocTitle", _b as "tocWrapper" }
